import * as React from 'react';

import SideNavigation from 'components/side-navigation-v2/SideNavigation';

import { addUserAction } from 'modules/tracking/providers/user-action-provider';

import { __t, applyTranslations } from 'utils/language';

import type { SideNavigationItem } from 'components/side-navigation-v2/SideNavigation.type';

applyTranslations(require('./reporting-side-navigation.i18n.json'));

type Props = {
  campaignId: number,
  reporting: Array<SideNavigationItem>,
  actions: Array<SideNavigationItem>
};

function trackClick(campaignId: number, trackingKey: string): void {
  addUserAction({
    eventCategory: 'reporting-subnavigation',
    eventAction: trackingKey
  });
}

const ReportingSideNavigation = (
  {
    campaignId,
    reporting,
    actions
  }: Props
): JSX.Element => (
  <SideNavigation
    items={[
      {
        type: 'container',
        title: __t('reporting_side_navigation.reporting_label'),
        children: reporting
      },
      {
        type: 'container',
        title: __t('reporting_side_navigation.actions_label'),
        children: actions
      }
    ]}
    onClick={(trackingKey) => trackClick(campaignId, trackingKey)}
  />
);

export default ReportingSideNavigation;
